import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevOps = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 8,
			width: 36,
			height: 22,
			rx: 2,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 19l4 4 8-8",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 30v6M16 40h16",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34,
			cy: 19,
			r: 3,
			stroke: "currentColor",
			strokeWidth: 1.2,
			opacity: .4
		})
	]
});
export default SvgDevOps;
